type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "center",
}: SectionHeadingProps) {
  const alignClass = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignClass} gap-3 mb-10 md:mb-14`}>
      <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium tracking-wide">
        <i className="ri-bookmark-3-line text-accent-600"></i>
        {eyebrow}
      </span>
      <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc ? (
        <p className={`text-sm md:text-base text-foreground-600 leading-relaxed ${align === "center" ? "max-w-3xl" : "max-w-2xl"}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}